import { useContext } from "react";
import { BreadcrumbsContext, UseBreadcrumbsPayload } from "./context";

export const useBreadcrumbs = (): UseBreadcrumbsPayload => {
	const context = useContext(BreadcrumbsContext);

	if (!context) {
		throw new Error("useBreadcrumbs must be used within a BreadcrumbsProvider");
	}

	return context;
};
